/**
 * Utilidades de validación del frontend
 * Validaciones adicionales antes de enviar datos
 */

/**
 * Valida que el tiempo de respuesta sea razonable
 * @param {number} tiempoSegundos - Tiempo en segundos
 * @param {number} numPreguntas - Número de preguntas
 * @returns {Object} {valido: boolean, mensaje: string}
 */
export const validarTiempoRespuesta = (tiempoSegundos, numPreguntas) => {
  // Tiempo mínimo más razonable: 5 segundos (antes era 10, muy restrictivo)
  const tiempoMinimo = 5;
  // Tiempo mínimo por pregunta: 2 segundos (antes era 3, muy restrictivo)
  const tiempoMinimoPorPregunta = 2;
  
  if (tiempoSegundos < tiempoMinimo) {
    return {
      valido: false,
      mensaje: `El tiempo de respuesta es muy corto. Por favor tómate al menos ${tiempoMinimo} segundos para completar la encuesta.`
    };
  }
  
  if (numPreguntas > 0) {
    const tiempoPorPregunta = tiempoSegundos / numPreguntas;
    if (tiempoPorPregunta < tiempoMinimoPorPregunta) {
      return {
        valido: false,
        mensaje: `El tiempo promedio por pregunta es muy bajo. Por favor lee y responde con cuidado.`
      };
    }
  }
  
  return { valido: true, mensaje: null };
};

/**
 * Valida que todas las respuestas estén completas
 * @param {Object} respuestas - Objeto con respuestas
 * @param {Array} preguntas - Array de preguntas
 * @returns {Object} {valido: boolean, mensaje: string}
 */
export const validarRespuestasCompletas = (respuestas, preguntas) => {
  if (!preguntas || preguntas.length === 0) {
    return { valido: false, mensaje: 'No hay preguntas en la encuesta' };
  }
  
  for (const pregunta of preguntas) {
    const respuesta = respuestas[pregunta.id_pregunta];
    
    if (!respuesta) {
      return {
        valido: false,
        mensaje: `Falta responder la pregunta: ${pregunta.texto}`
      };
    }
    
    if (pregunta.tipo === 'opcion_multiple' && !respuesta.id_opcion) {
      return {
        valido: false,
        mensaje: `Debes seleccionar una opción para: ${pregunta.texto}`
      };
    }
    
    if (pregunta.tipo === 'texto_libre' && (!respuesta.respuesta_texto || !respuesta.respuesta_texto.trim())) {
      return {
        valido: false,
        mensaje: `Debes completar el texto para: ${pregunta.texto}`
      };
    }
  }
  
  return { valido: true, mensaje: null };
};

/**
 * Valida formato de datos demográficos
 * @param {Object} datosDemograficos - Datos demográficos
 * @returns {Object} {valido: boolean, mensaje: string}
 */
export const validarDatosDemograficos = (datosDemograficos) => {
  if (!datosDemograficos) {
    return { valido: true, mensaje: null }; // Opcionales
  }
  
  if (datosDemograficos.completo_datos === false) {
    return { valido: true, mensaje: null }; // No desea completar
  }
  
  // Validar edad si se proporciona
  if (datosDemograficos.edad !== null && datosDemograficos.edad !== undefined) {
    if (isNaN(datosDemograficos.edad) || datosDemograficos.edad < 1 || datosDemograficos.edad > 120) {
      return {
        valido: false,
        mensaje: 'La edad debe ser un número entre 1 y 120'
      };
    }
  }
  
  // Validar sexo si se proporciona
  if (datosDemograficos.sexo && !['M', 'F', 'Otro'].includes(datosDemograficos.sexo)) {
    return {
      valido: false,
      mensaje: 'El sexo debe ser M, F u Otro'
    };
  }
  
  return { valido: true, mensaje: null };
};

